export class MarketStructList {

    marketList = []
}
